import { v4 as uuidv4 } from "uuid";

export default function getChoiceOption({
  type = "option",
  title,
  number = -1,
  img = "",
}) {
  return {
    id: `${uuidv4()}`,
    type: type,
    title: title,
    number: number,
    img: img,
  };
}
